import { BadgePrimitive, LoadingSpinner, Toast } from '@figma/fpl-components';
import cssVars from '@figma/fpl-tokens/css-vars';
import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { Box } from '@/UI/Box/Box';
import { typographyStyles } from '@/UI/AppTypography/AppTypography';
import { I18N_KEYS } from '@/language/keys';

export function BufferingIndicator({ asToast = false }: { asToast?: boolean }) {
  const { t } = useTranslation();
  const message = `${t(I18N_KEYS.COMMON_COMPONENTS.MEDIA_BUFFERING)}...`;

  if (asToast) {
    return (
      <Toast.Root>
        <Toast.Spinner />
        <Toast.Message role="status">{message}</Toast.Message>
      </Toast.Root>
    );
  }

  return (
    <Box
      component={BadgePrimitive}
      role="status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 24,
        pl: 0.5,
        pr: 0.75,
        gap: 0.5,
        borderRadius: cssVars.radius.medium,
        backgroundColor: cssVars.ramp.grey800,
        color: `color-mix(in srgb, ${cssVars.ramp.white1000} 90%, transparent)`,
        boxShadow: cssVars.elevation.x300,
        '--fpl-icon-color': 'currentColor',
      }}
    >
      <div aria-hidden="true">
        <LoadingSpinner size="sm" />
      </div>
      <span {...stylex.props(typographyStyles.textBodyLarge)}>{message}</span>
    </Box>
  );
}
